<form [formGroup]="forecastVersionSettingsFormGroup">
  <pm-form-field
    label="CONFIGURATION.FORM.FORECAST_VERSION_SETTINGS.INCLUDE_DATA_UNTIL"
    class="py-2 w-full block"
  >
    <pm-form-input-date
      [formControlName]="
        ForecastVersionSettingsFormControlNames.INCLUDE_DATA_UNTIL
      "
    />
  </pm-form-field>

  <!-- Batch Processing -->
  <pm-form-input-checkbox
    kind="switch"
    [formControlName]="
      ForecastVersionSettingsFormControlNames.IS_BATCH_PROCESSING
    "
    class="mb-4 block"
  >
    {{
      'CONFIGURATION.FORM.FORECAST_VERSION_SETTINGS.MORE_THAN_ONE_FORECAST'
        | translate
    }}
  </pm-form-input-checkbox>
  <!-- Horizon (Shown conditionally) -->
  @if (forecastVersionSettingsFormGroup.controls.isBatchProcessing?.value) {
    <label
      class="block mb-2"
      [for]="ForecastVersionSettingsFormControlNames.FREQUENCY"
    >
      {{
        'CONFIGURATION.FORM.FORECAST_VERSION_SETTINGS.TIME_PERIOD_BETWEEN_FORECAST_VERSIONS'
          | translate
      }}</label
    >
    <mat-radio-group
      [formControlName]="ForecastVersionSettingsFormControlNames.FREQUENCY"
      class="flex mb-4"
    >
      <mat-radio-button [value]="Resolution.Daily">{{
        'RESULT.SIDEBAR.RESOLUTION.DAILY' | translate
      }}</mat-radio-button>
      <mat-radio-button [value]="Resolution.Weekly">{{
        'RESULT.SIDEBAR.RESOLUTION.WEEKLY' | translate
      }}</mat-radio-button>
      <mat-radio-button [value]="Resolution.Monthly">{{
        'RESULT.SIDEBAR.RESOLUTION.MONTHLY' | translate
      }}</mat-radio-button>
    </mat-radio-group>
    @if (
      forecastVersionSettingsFormGroup.controls.frequency?.value ===
      Resolution.Monthly
    ) {
      <pm-form-input-checkbox
        kind="switch"
        class="mb-4 block"
        [formControlName]="
          ForecastVersionSettingsFormControlNames.USE_END_OF_MONTH
        "
      >
        {{
          'CONFIGURATION.FORM.FORECAST_VERSION_SETTINGS.USE_END_OF_MONTH'
            | translate
        }}
      </pm-form-input-checkbox>
    }
    <pm-form-field
      label="CONFIGURATION.FORM.FORECAST_VERSION_SETTINGS.REPEAT_UNTIL"
      class="w-full block"
    >
      <pm-form-input-date
        [formControlName]="
          ForecastVersionSettingsFormControlNames.LAST_RELEVANT_ACTUAL_DATE
        "
      />
    </pm-form-field>
  }
</form>
